import type { PublisherAction } from '@planuze/admin-contracts';
import { Button, Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from '@planuze/ui';
import { useState } from 'react';
import { usePublishersContent } from '../../content/sections/publishers.js';
import { BulkSelectionBar } from '../bulk-selection-bar.js';

/* Barra de ação em lote (ADR-0471): aparece quando há seleção. A confirmação (com motivo)
   fica no page. ban/unban só entram na lista para super_admin. */

const BASE_ACTIONS: readonly PublisherAction[] = ['verify', 'suspend', 'unsuspend'];
const SUPER_ADMIN_ACTIONS: readonly PublisherAction[] = ['ban', 'unban'];

export function BulkActionBar({
  selectedCount,
  isSuperAdmin,
  busy,
  onApply,
  onClear,
}: {
  readonly selectedCount: number;
  readonly isSuperAdmin: boolean;
  readonly busy: boolean;
  readonly onApply: (action: PublisherAction) => void;
  readonly onClear: () => void;
}) {
  const [action, setAction] = useState<PublisherAction>('suspend');
  const copy = usePublishersContent();
  const actions = isSuperAdmin ? [...BASE_ACTIONS, ...SUPER_ADMIN_ACTIONS] : BASE_ACTIONS;
  if (selectedCount === 0) return null;
  return (
    <div className="mb-3">
      <BulkSelectionBar
        selectedLabel={copy.bulkAction.selectedCount(selectedCount)}
        clearLabel={copy.bulkAction.clearSelection}
        busy={busy}
        onClear={onClear}
      >
        <Select value={action} onValueChange={(v) => setAction(v as PublisherAction)}>
          <SelectTrigger className="h-9 w-44" aria-label={copy.bulkAction.ariaLabel}>
            <SelectValue />
          </SelectTrigger>
          <SelectContent>
            {actions.map((a) => (
              <SelectItem key={a} value={a}>
                {copy.actionLabels[a]}
              </SelectItem>
            ))}
          </SelectContent>
        </Select>
        <Button size="sm" disabled={busy} onClick={() => onApply(action)}>
          {copy.bulkAction.apply}
        </Button>
      </BulkSelectionBar>
    </div>
  );
}
